export const failureTypeEllipsisHeaderOptions = [
  { label: 'Add New Failure Type', value: 'add', callback: 'onClickAdd' },
];
